module.exports = __webpack_public_path__ + "img/SD-fig1.6041f9a1.svg";